import { Injectable, Inject, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CanaryTokenService {
  private renderer: Renderer2;

  constructor(private rendererFactory: RendererFactory2, @Inject(DOCUMENT) private document: Document) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public initialize(): void {
    // Check if the property exists and is a non-empty array
    if (!environment.canaryTokenScripts || !Array.isArray(environment.canaryTokenScripts) || environment.canaryTokenScripts.length === 0) {
      return;
    }

    const currentHostname = window.location.hostname;

    // Use 'as any[]' to bypass the strict type inference on empty arrays
    // Use '.includes()' for a more robust domain check (handles www. subdomains)
    const tokenConfig = (environment.canaryTokenScripts as any[]).find((token) => token && token.domain && currentHostname.includes(token.domain));

    if (tokenConfig && tokenConfig.scriptContent) {
      this.injectInlineScript(tokenConfig.scriptContent);
    }
  }

  private injectInlineScript(content: string): void {
    const script = this.renderer.createElement('script');
    this.renderer.setAttribute(script, 'type', 'text/javascript');
    script.textContent = content;
    this.renderer.appendChild(this.document.head, script);
  }
}
